import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PostingCard } from "./postingCard";
import { Post } from "./PostModel";
import Pagination from "./pagination";
import defaultAxios from 'axios';
import { backendUrl, imageDeleteUrl, imageUploadUrl } from "../../../common/constantVarialble";
import Tiptap from "./tiptap";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import HashTagInput from "./hashTagInput";
import { useAuth } from "../../../AuthContext";
import '../../../styles/global.css'
import { Color } from '@tiptap/extension-color'
import ListItem from '@tiptap/extension-list-item'
import TextStyle from '@tiptap/extension-text-style'
import { EditorContent, EditorProvider, useCurrentEditor, useEditor } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import Heading from '@tiptap/extension-heading'
import Placeholder from "@tiptap/extension-placeholder";
import axios from "axios";
import Image from "@tiptap/extension-image";
import HashtagList from "./hashTagList";
import { TextEditMenuBar } from "./textEditMenuBar";

interface PostingDetail {
    chain_code: string,
    permlink: string,
    title: string,
    content: string,
    tags: string[],
    promise_date: string,
    input_psn: string,
    create_id: string,
    input_dte: string,
    steem_sync_status: string,
    steem_author: string | null,
    steem_voter: string | null,
    steem_self_voting_status: string,
    steem_post_sync_date: string | null,
    steem_self_voting_date: string | null,
    steem_payout_estimate_date: string | null,
    steem_payout_yn: string,
    steem_payout_date: string | null,
    steem_author_payout_value: string,
    steem_author_distribution_yn: string,
    steem_author_distribution_date: string | null,
    steem_service_voting_date: string | null,
    steem_service_vote_finish_yn: string,
    hive_sync_status: string,
    hive_author: string | null,
    hive_voter: string | null,
    hive_self_voting_status: string,
    hive_post_sync_date: string | null,
    hive_self_voting_date: string | null,
    hive_payout_estimate_date: string | null,
    hive_payout_yn: string,
    hive_payout_date: string | null,
    hive_author_payout_value: string,
    hive_author_distribution_yn: string,
    hive_author_distribution_date: string | null,
    hive_service_voting_date: string | null,
    hive_service_vote_finish_y: string
}

interface DescriptionProps {
    title: string,
    description: string,
    option: string // basic, steem, hive
}

/**
 * 서비스 포스팅 상세 설명 컴포넌트
 * 
 * @param title: 상세설명 항목(제목)
 * @param description: 상세 설명
 * @param option: basic, steem, hive
 * @returns Component
 */
const Description: React.FC<DescriptionProps> = ({ title, description, option }) => {
    return (
        <div className="flex flex-row gap-4 items-center ">
            <p className={`text-sm font-thin ${option == 'steem' ? 'text-blue-500' : option == 'hive' ? 'text-red-500' : 'text-gray-200'}`}>{title} :</p>
            <p className={`italic text-xs font-thin ${option == 'steem' ? 'text-cyan-300' : option == 'hive' ? 'text-amber-300' : 'text-gray-400'}`}>{description}</p>
        </div>
    );
}

function PostingUpdateScreen() {
    const [searchParams] = useSearchParams();
    const permlink = searchParams.get("permlink");
    const [posting, setPosting] = useState<PostingDetail | null>(null);
    const [title, setTitle] = useState(""); // Title(제목)
    const [imageUrls, setImageUrls] = useState<string[]>([]); // 이미지 배열
    const [imageUrlKeys, setImageUrlKeys] = useState<string[]>([]); // 이미지 키 배열
    const [hashTags, setHashTags] = useState<string[]>([]); // 해시태그 리스트    
    const [promiseDate, setPromiseDate] = useState<Date | null>(new Date()); // 포스팅 예약 날짜
    const { user } = useAuth(); // 포스팅 작성 User ID
    const navigate = useNavigate();



    const editorProps = {
        attributes: {
            class: 'text-sm leading-6 text-black  focus:outline-none p-6 bg-slate-200 min-h-96 mb-2 rounded-b-md',
        } //p
    };
    const extensions = [
        Color.configure({ types: [TextStyle.name, ListItem.name] }),
        //TextStyle.configure({ types: [ListItem.name] }),
        Heading.configure({
            levels: [1, 2, 3, 4, 5, 6],
        }),
        StarterKit.configure({
            bulletList: {
                keepMarks: true,
                keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
            },
            orderedList: {
                keepMarks: true,
                keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
            },
        }),
        Placeholder.configure({
            placeholder: "Please input your detail",
        }),
        Image.configure({
            inline: true,
            HTMLAttributes: {
                class: "custom-img-class",
            },
        }),
    ];

    // Main Editor
    const mainEditor = useEditor({
        editorProps,
        extensions,
        // editable: true,
        // injectCSS: false,
        content: "",
    });


    const getSaveImageList = () => {
        const json = mainEditor?.getJSON();
        let aImageSrc: string[] = [];

        if (json && json.content && json.content.length) {
            for (let i = 0; i < json.content.length; i++) {
                const jsonContent = json.content[i];

                // jsonContent.content가 존재하는지 확인
                if (jsonContent.content) {
                    for (let j = 0; j < jsonContent.content.length; j++) {
                        const jsonElement = jsonContent.content[j];

                        // jsonElement가 존재하고 타입이 'image'인지 확인
                        if (jsonElement && jsonElement.type === "image") {
                            console.log("jsonElement", jsonElement);
                            const imageSrc = jsonElement.attrs?.src;
                            if (imageSrc) {
                                aImageSrc.push(imageSrc);
                            }
                        }
                    }
                }
            }
        }

        return aImageSrc;
    };

    // 게시물 저장(Create)
    const onUpdateBtnClick = async () => {
        if (title.trim() == "") {
            alert("제목을 입력하세요");
            return;
        }
        if (mainEditor?.getHTML().trim() == "") {
            alert("본문을 입력하세요");
            return;
        }
        let p_permlink: string = permlink!;
        let p_content = mainEditor?.getHTML().trim();
        let p_uid: string = user?.uid ?? "";
        let p_hashTagListString: string = `{${hashTags.join(',')}}`;
        let p_imageList = getSaveImageList();
        let p_imageListString: string = `{${p_imageList.join(',')}}`;

        // 삭제할 이미지 키값(실제 저장되지 않는 이미지의 키값)
        let excludedImageKeys: string[] = [];

        // 저장할 이미지 키값
        let saveImageKeys: string[] = [];

        for (let i = 0; i < imageUrlKeys.length; i++) {
            let isKeyContained: boolean = false;
            let l_image_url_key: string = imageUrlKeys[i];

            for (let k = 0; k < p_imageList.length; k++) {
                let l_image_url: string = p_imageList[k];

                // key가 URL에 포함되어 있는지 확인
                if (l_image_url.includes(l_image_url_key)) {
                    isKeyContained = true;
                    break;
                }
            }

            // key가 URL에 포함되어 있는 경우 
            if (isKeyContained) {
                saveImageKeys.push(l_image_url_key);
            }
            // key가 URL에 포함되어 있지 않은 경우 
            else {
                excludedImageKeys.push(l_image_url_key);
            }
        }

        let p_imageKeyListString = `{${saveImageKeys.join(',')}}`


        // console.log("permlink", p_permlink);
        // console.log("title", title);
        // console.log("content", p_content);
        // console.log("uid", p_uid);
        // console.log("hashTagListString", p_hashTagListString);
        // console.log("imageListString", p_imageListString);
        // console.log("p_imageKeyListString", p_imageKeyListString);
        // console.log("excludedImageKeys", excludedImageKeys);
        // console.log("p_imageList", p_imageList);
        // console.log("saveImageKeys", saveImageKeys);
        // console.log("imageUrlKeys", imageUrlKeys);

        // 1. Create Service Post
        const { data } = await axios({
            method: 'post',
            //url: 'http://localhost:5000/api/request/',
            url: backendUrl,
            data: {
                program_id: 'PERCENT-ENG-POSTING-P-UPDSERVICEPOSTING',
                params: {
                    'p_perm_link': p_permlink,
                    'p_title': title,
                    'p_content': p_content,
                    'p_image_urls': p_imageListString,
                    'p_image_url_keys': p_imageKeyListString,
                    'p_tags': p_hashTagListString,
                    'p_promise_date': promiseDate,
                    'p_user_id': p_uid,
                },
                page_index: -1,
            },
        });

        // 2. Dangling Image 데이터 삭제
        await axios({
            method: 'post',
            //url: 'http://localhost:5000/api/request/',
            url: imageDeleteUrl,
            data: {
                params: {
                    'delete_image_keys': excludedImageKeys,
                },
            },
        });


        // 3. 저장된 포스팅 페이지로 이동
        navigate(`/admin/posting?permlink=${p_permlink}`);

    }




    const fetchPosting = async (permlink: string) => {
        try {
            if (permlink == "") return;
            const { data } = await axios({
                method: "post",
                url: backendUrl,
                data: {
                    program_id: "PERCENT-ENG-POSTING-S-LSTSERVICEPOSTINGBYPERMLINK",
                    params: {
                        p_permlink: permlink
                    },
                    initial_start_index: 0,
                    page_index: -1,
                    item_count: 0,
                },
            });
            return data;
        } catch (error) {
            console.error(error);
            return null;
        }
    }

    // 포스팅 디테일 로드
    useEffect(() => {
        const loadPosting = async () => {
            let posting = await fetchPosting(permlink ?? "");
            if (posting && posting.data.length > 0) {
                console.log("post detail", posting.data[0]);
                setPosting(posting.data[0]);
                setTitle(posting.data[0].title); // 제목 상태 설정
                setImageUrls(posting.data[0].image_urls);
                setImageUrlKeys(posting.data[0].image_url_keys);
                setHashTags(posting.data[0].tags);
                setPromiseDate(posting.data[0].promise_date);
            }
        }

        loadPosting();
    }, [permlink])

    // 포스팅 정보 업데이트시 에디터의 본문(Content) 업데이트
    useEffect(() => {
        if (posting) {
            mainEditor?.commands.setContent(posting.content);
        }
    }, [posting, mainEditor]);

    return (<div className="flex flex-1 min-h-screen bg-gray-800 py-12 px-24 flex-col items-center">

        <div className="w-2/3">

            <div className="flex flex-row w-full bg-gray-700 rounded-lg">
                <div className="flex flex-col m-2 px-6">
                    <div className="flex flex-row items-center justify-between mb-6 pb-6 border-b border-gray-500">
                        <div className='flex flex-row gap-x-3 items-center'>
                            <p className="text-gray-200 text-xl font-bold">예약 포스팅 날짜 :</p>
                            <DatePicker
                                className="px-2 py-1 rounded border-none bg-slate-200"
                                dateFormat='yyyy.MM.dd' // 날짜 형태
                                shouldCloseOnSelect // 날짜를 선택하면 datepicker가 자동으로 닫힘
                                selected={promiseDate}
                                onChange={(date) => setPromiseDate(date)}
                                onKeyDown={(e) => {
                                    e.preventDefault();
                                }}
                            />
                        </div>
                        <div className="flex flex-row gap-x-2">
                            <button className="group relative h-10 w-40 overflow-hidden rounded-2xl bg-cyan-500 text-lg font-bold text-white" onClick={onUpdateBtnClick}>
                                Update
                                <div className="absolute inset-0 h-full w-full scale-0 rounded-2xl transition-all duration-300 group-hover:scale-100 group-hover:bg-white/30"></div>
                            </button>
                        </div>
                    </div>
                    <div className="flex flex-row justify-between">
                        <input
                            className="text-sm w-full px-2 py-2 my-4 h-fit rounded main-input outline-none bg-slate-200"
                            id="inputTitle"
                            onChange={(e) => setTitle(e.target.value)} // title 상태 업데이트
                            placeholder="제목을 입력해주세요"
                            value={title}
                            required
                        />

                    </div>
                    <TextEditMenuBar
                        imageUrls={imageUrls}
                        setImageUrls={setImageUrls}
                        imageUrlKeys={imageUrlKeys}
                        setImageUrlKeys={setImageUrlKeys}
                        editor={mainEditor}
                    />
                    <EditorContent editor={mainEditor} />
                    <div className="mb-4">
                        <HashtagList hashState={posting?.tags ?? []} />
                    </div>
                </div>

            </div>



        </div>
    </div>);
}

export { PostingUpdateScreen };